import React from "react";

import Button from "@mui/material/Button";
import UploadIcon from "@mui/icons-material/Upload";
import Modal from "./Modal";
import "./Navbar.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
export default function Navbar({ children, search, handleSearch }) {
  const [showModal, setShowModal] = useState(false);

  const handleUpload = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="navBar">
        <Link to="/">
          <img src="/Logo.png" style={{ height: "29.29px", width: "60px" }} />
        </Link>
        {children && (
          <div style={{ display: "flex" }} id="search-input">
            <TextField
              sx={{
                width: "20rem",
                maxWidth: "100%",
                borderRadius: "none",
                // border: "1px solid #606060",
              }}
              className="search-desktop btnabc"
              fullWidth
              id="outlined-size-small"
              placeholder="Search"
              size="small"
              value={search}
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
            />

            <Button
              className="search-desktop btnabc"
              style={{
                backgroundColor: "#444D56",
                paddingRight: "2px",
              }}
              variant="contained"
              startIcon={<SearchIcon className=" btn-mobile" />}
            ></Button>
          </div>
        )}
        {children && (
          <Button
            id="upload-btn"
            variant="contained"
            onClick={handleUpload}
            className="uploadButton"
          >
            <UploadIcon />
            Upload
          </Button>
        )}
        {showModal && <Modal isActive={handleUpload} />}
      </div>
    </>
  );
}
